import { Component, OnInit } from '@angular/core';
import {MyserviceService} from '../myservice.service';
import {Router} from '@angular/router';

@Component({
  selector: 'app-admin',
  templateUrl: './admin.component.html',
  styleUrls: ['./admin.component.css'],
  providers:[MyserviceService]
})
export class AdminComponent implements OnInit {

  constructor(private serv:MyserviceService) { }
  user:any;
  feed:any;
  ngOnInit(): void {
    this.serv.feedbacks().subscribe(
      data=>{
        this.feed=data;
      },
      error=>{

      }
    );
    this.serv.users().subscribe(
      data=>{
        this.user=data;
        console.log(this.user);
      },
      error=>{
        console.log("Error");
      }
    );
  }

  public show:boolean = false;
  public buttonName:any = 'User Reviews';
  toggle() {

    this.show = !this.show;
    if(this.show)
      this.buttonName = "Close";
    else
      this.buttonName = "User Reviews";

  }

  delete(username){
    console.log(username);
    this.serv.del(username).subscribe(
      data=>{
        console.log("Deleted");
        this.serv.users().subscribe(
          data=>{
            this.user=data;
            console.log(this.user);
          },
          error=>{
            console.log("Error");
          }
        )
        console.log(data);
      },
      error=>{
        console.log("Error");
      }
    )
  }
}
